export default __webpack_public_path__ + "static/workspace-b039c6de79154ac18ceffa3918eed4b2.png";